/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  width: 90px;
  background: #fff;

  flex-direction: column;
  display: flex;
  justify-content: space-between;
  align-items: center;

  border-top-right-radius: 19px;
  border-bottom-right-radius: 19px;

  box-shadow: 2.4px 2.4px 2.4px 2.4px #aaa;

  position: fixed;
`;

export const ViewTop = styled.div`
  height: 10vh;
  width: 90px;
  margin: 0 auto;
  padding-top: 10px;

  div.support {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img:hover {
      cursor: pointer;
    }
  }

  div.admin {
    text-align: center;
  }
`;

export const ViewBody = styled.div`
  height: 40vh;
  width: 90px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  div: {
    button: {
      background: none;
      border: 0;
    }
  }
`;

export const ViewBottom = styled.div`
  height: 15vh;
  width: 90px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;

  div.bottom {
    div {
      button: {
        background: none;
        border: 0;
      }
    }
  }
`;

export const ViewToolTip = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 300px;
  height: 100px;
  margin-left: 20px;
  margin-top: -20px;
  padding: 10px;

  background: #090f35;
  border: 3px solid #36ded6;
  border-radius: 5px;
  color: #fff;

  p {
    margin-top: 5px;
    margin-bottom: 5px;
    text-align: center;
    font-size: 16px;
  }

  &::before {
    content: '';
    position: absolute;
    /* right: 12px; */
    left: 5px;
    top: -3px;
    width: 0;
    height: 0;
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;
    border-right: 15px solid #36ded6;
  }
`;
